/** Tipo MIME para arrastar tarefas entre colunas do quadro. */
export const TAREFA_DRAG_MIME = "application/x-pbisemog-tarefa-id";

export function setTarefaDragData(dataTransfer: DataTransfer, tarefaId: string): void {
  dataTransfer.setData(TAREFA_DRAG_MIME, tarefaId);
  dataTransfer.setData("text/plain", tarefaId);
  dataTransfer.effectAllowed = "move";
}

export function getTarefaDragId(dataTransfer: DataTransfer): string | null {
  const id = dataTransfer.getData(TAREFA_DRAG_MIME) || dataTransfer.getData("text/plain");
  return id.trim() || null;
}
